// src/components/Report/shared/ZeroAttemptedBanner.jsx
import React from "react";

export default function ZeroAttemptedBanner({ total }) {
  return (
    <div className="dlg-zero-banner">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
      <span>
        <strong>{total} student{total !== 1 ? "s" : ""} assigned</strong> — no one has attempted the test yet
      </span>
    </div>
  );
}